import { render, staticRenderFns } from "./tab_01.vue?vue&type=template&id=57ed73ea&scoped=true&"
import script from "./tab_01.vue?vue&type=script&lang=js&"
export * from "./tab_01.vue?vue&type=script&lang=js&"
import style0 from "./tab_01.vue?vue&type=style&index=0&id=57ed73ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed73ea",
  null
  
)

export default component.exports